export default function isNotUndefined(element) {
    if(element === undefined) {
        return " - ";
    }
    return element
}